/* July London: the Dore & Rose layer. Swiper for every slider (data-swiper JSON), PhotoSwipe zoom on the product
   gallery, product tabs, quick add with a height picker, collection filter panel, header search. Runs after theme.js. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var hasSwiper = function () { return typeof window.Swiper === 'function'; };

  /* ---------- Swipers from data-swiper ---------- */
  function sectionOf(el) { return el.closest('.dr-tabs, .shopify-section, section') || document; }
  function initSwiper(el) {
    if (el.__dr || el.swiper) return;
    el.__dr = true;
    if (!hasSwiper()) { el.classList.add('dr-noswiper'); return; }
    var opts = {};
    try { opts = JSON.parse(el.getAttribute('data-swiper') || '{}'); } catch (e) { opts = {}; }
    opts.observer = true; opts.observeParents = true; opts.watchOverflow = true;
    if (opts.pagination && typeof opts.pagination.el === 'string') {
      opts.pagination.el = el.querySelector(opts.pagination.el) || sectionOf(el).querySelector(opts.pagination.el);
      if (!opts.pagination.el) delete opts.pagination;
    }
    if (el.classList.contains('dr-row')) {
      var scope = el.closest('.dr-tabs__panel') ? el.closest('.dr-tabs') : sectionOf(el);
      if (!el.closest('.dr-tabs__panel')) {
        var prev = $('[data-dr-prev]', scope), next = $('[data-dr-next]', scope);
        if (prev && next) opts.navigation = { prevEl: prev, nextEl: next };
      }
    }
    try { new window.Swiper(el, opts); } catch (e) { el.classList.add('dr-noswiper'); }
  }
  function initSwipers(scope) { $$('[data-swiper]', scope || document).forEach(initSwiper); }

  /* Tab arrows drive the swiper in the visible panel */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dr-prev], [data-dr-next]');
    if (!b) return;
    var tabs = b.closest('.dr-tabs');
    if (!tabs) return;
    var panel = $$('.dr-tabs__panel', tabs).filter(function (p) { return !p.hidden; })[0];
    var sw = panel && $('.swiper', panel);
    if (sw && sw.swiper) { if (b.hasAttribute('data-dr-prev')) sw.swiper.slidePrev(); else sw.swiper.slideNext(); }
  });

  /* ---------- Product tabs ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-dr-tab]');
    if (!tab) return;
    var root = tab.closest('[data-dr-tabs]');
    $$('[data-dr-tab]', root).forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
    var id = tab.getAttribute('aria-controls');
    $$('.dr-tabs__panel', root).forEach(function (p) {
      p.hidden = p.id !== id;
      if (!p.hidden) { var sw = $('.swiper', p); if (sw && sw.swiper) { sw.swiper.update(); sw.swiper.slideTo(0, 0); } }
    });
  });

  /* ---------- Product gallery: Swiper + thumbs + PhotoSwipe ---------- */
  function initGallery(root) {
    if (root.__dr) return;
    root.__dr = true;
    var mainEl = $('.dr-gallery__main', root), thumbsEl = $('.dr-gallery__thumbs', root);
    var idx = $('[data-dr-gallery-index]', root);
    var start = parseInt(root.getAttribute('data-start'), 10) || 0;
    if (!hasSwiper()) { mainEl.classList.add('dr-noswiper'); return; }
    var thumbs = null;
    if (thumbsEl) {
      thumbs = new window.Swiper(thumbsEl, { slidesPerView: 'auto', spaceBetween: 8, watchSlidesProgress: true, slideToClickedSlide: true });
    }
    var main = new window.Swiper(mainEl, {
      initialSlide: start, speed: 450, spaceBetween: 0, observer: true, observeParents: true,
      navigation: { prevEl: $('[data-dr-gallery-prev]', root), nextEl: $('[data-dr-gallery-next]', root) },
      thumbs: thumbs ? { swiper: thumbs } : undefined,
      on: { slideChange: function (s) { if (idx) idx.textContent = s.activeIndex + 1; } }
    });
    root.__swiper = main;
    if (window.PhotoSwipeLightbox && window.PhotoSwipe) {
      try {
        var lb = new window.PhotoSwipeLightbox({
          gallery: mainEl, children: 'a.dr-gallery__zoom', pswpModule: window.PhotoSwipe,
          bgOpacity: 1, showHideAnimationType: 'fade', padding: { top: 20, bottom: 20, left: 0, right: 0 }
        });
        lb.on('change', function () { var i = lb.pswp && lb.pswp.currIndex; if (typeof i === 'number') main.slideTo(i, 0); });
        lb.init();
      } catch (e) {}
    } else {
      $$('a.dr-gallery__zoom', root).forEach(function (a) { a.addEventListener('click', function (ev) { ev.preventDefault(); }); });
    }
  }
  function initGalleries(scope) { $$('[data-dr-gallery]', scope || document).forEach(initGallery); }
  document.addEventListener('variant:change', function (e) {
    var v = e.detail; if (!v || !v.media) return;
    var root = e.target.querySelector ? e.target.querySelector('[data-dr-gallery]') : null;
    root = root || $('[data-dr-gallery]');
    if (!root || !root.__swiper) return;
    var slides = $$('.dr-gallery__main .swiper-slide', root);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-media-id') === String(v.media)) { root.__swiper.slideTo(i); break; }
    }
  });

  /* ---------- Quick add with a height picker ---------- */
  function closeQA(except) {
    $$('[data-qa]').forEach(function (p) {
      if (p === except) return;
      p.hidden = true;
      var t = p.parentNode && $('[data-qa-toggle]', p.parentNode); if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-qa-toggle]');
    if (t) {
      e.preventDefault();
      var panel = $('[data-qa]', t.parentNode);
      var open = panel.hidden;
      closeQA(panel);
      panel.hidden = !open;
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (e.target.closest('[data-qa-close]')) { closeQA(); return; }
    var opt = e.target.closest('.pgi__qa-opt[data-quick-add]');
    if (opt) {
      setTimeout(function () { opt.classList.add('is-added'); }, 10);
      setTimeout(function () { closeQA(); opt.classList.remove('is-added'); }, 900);
      return;
    }
    if (!e.target.closest('[data-qa]')) closeQA();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQA(); });

  /* ---------- Collection filters: hide on desktop, slide-in panel on phones ---------- */
  var desk = window.matchMedia('(min-width: 990px)');
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-filters-toggle]');
    if (t) {
      var coll = t.closest('[data-dr-coll]');
      if (desk.matches) {
        var col = coll.classList.toggle('is-collapsed');
        t.setAttribute('aria-expanded', col ? 'false' : 'true');
        try { sessionStorage.setItem('dr-filters', col ? 'hidden' : 'shown'); } catch (er) {}
      } else {
        coll.classList.add('is-open');
        document.body.classList.add('is-locked');
      }
      return;
    }
    var c = e.target.closest('[data-filters-close]');
    if (c) {
      var cl = c.closest('[data-dr-coll]');
      if (cl) cl.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      return;
    }
    var more = e.target.closest('[data-fmore]');
    if (more) {
      var list = more.previousElementSibling;
      var ex = list.classList.toggle('is-expanded');
      more.textContent = ex ? 'Show less' : 'Show more';
    }
  });
  function restoreFilters() {
    var coll = $('[data-dr-coll]');
    if (!coll) return;
    try { if (desk.matches && sessionStorage.getItem('dr-filters') === 'hidden') { coll.classList.add('is-collapsed'); var t = $('[data-filters-toggle]', coll); if (t) t.setAttribute('aria-expanded', 'false'); } } catch (e) {}
  }

  /* ---------- Header: search panel and scrolled shadow ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-search-open]');
    if (o) {
      var panel = $('[data-search]');
      if (!panel) return;
      e.preventDefault();
      panel.hidden = !panel.hidden;
      if (!panel.hidden) { var i = $('input[type="search"]', panel); if (i) setTimeout(function () { i.focus(); }, 30); }
      return;
    }
    if (e.target.closest('[data-search-close]')) { var p = $('[data-search]'); if (p) p.hidden = true; }
  });
  var head = $('[data-header]');
  if (head) {
    var onScroll = function () { head.classList.toggle('is-scrolled', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Cart drawer: refresh sliders when it opens ---------- */
  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () {
      if (drawer.classList.contains('is-open')) $$('.swiper', drawer).forEach(function (s) { if (s.swiper) s.swiper.update(); });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Init, and again whenever theme.js swaps in new HTML ---------- */
  function init(scope) { initSwipers(scope); initGalleries(scope); }
  init(document);
  restoreFilters();
  if (window.MutationObserver) {
    var tmr = null;
    new MutationObserver(function (list) {
      var hit = list.some(function (m) { return m.addedNodes && m.addedNodes.length; });
      if (!hit) return;
      clearTimeout(tmr); tmr = setTimeout(function () { init(document); }, 40);
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.SLDR = { init: init };
})();
